/** 绘本控制条图标 symbol 名称 */
export const BOOK_ICON_NAMES = {
  BOOK_PREVIOUS: 'book-previous',
  BOOK_PLAY: 'book-play',
  BOOK_PAUSE: 'book-pause',
  BOOK_NEXT: 'book-next',
  BOOK_SOUND: 'book-sound',
  BOOK_SOUND_OFF: 'book-sound-off',
  BOOK_ZOOM: 'book-zoom',
  BOOK_ZOOM_RESTORE: 'book-zoom-restore',
  BOOK_FULLSCREEN: 'book-fullscreen',
  BOOK_FULLSCREEN_EXIT: 'book-fullscreen-exit',
  BOOK_SHARE: 'book-share',
  BOOK_HEADER_LOGO: 'book-header-logo',
  BOOK_HEADER_CTA: 'book-header-cta'
} as const;

export type BookIconName = (typeof BOOK_ICON_NAMES)[keyof typeof BOOK_ICON_NAMES];
